"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: cash-deposit/cash-deposit-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcash-deposit%2Fcash-deposit-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashDepositServiceClient = exports.depositErrorCodeToJSON = exports.depositErrorCodeFromJSON = exports.LookupFeeSchemaResponse = exports.LookupFeeSchemaRequest = exports.GetLocationsResponse = exports.GetLocationsRequest = exports.AssignBarcodeResponse = exports.AssignBarcodeRequest = exports.GetActiveBarcodeResponse = exports.GetActiveBarcodeRequest = exports.GetBarcodeResponse = exports.GetBarcodeRequest = exports.Barcode = exports.DepositErrorCode = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const fee_schema_1 = require("../common/fee-schema");
const latlng_1 = require("../google/type/latlng");
const payment_cash_deposit_1 = require("../ledger/payment-cash-deposit");
const protobufPackage = 'com.step.cashdeposit.proto';
var DepositErrorCode;
(function (DepositErrorCode) {
    DepositErrorCode["INVALID_DEPOSIT_ERROR_CODE"] = "INVALID_DEPOSIT_ERROR_CODE";
    /**
     * NOT_ALLOWED - Deposit failed due to account state. E.g account is closed or suspended.
     */
    DepositErrorCode["NOT_ALLOWED"] = "NOT_ALLOWED";
    /**
     * BARCODE_EXPIRED - Deposit failed because the barcode was expired.
     */
    DepositErrorCode["BARCODE_EXPIRED"] = "BARCODE_EXPIRED";
    /**
     * LIMITS_EXCEEDED - Deposit failed because limits were exceeded.
     */
    DepositErrorCode["LIMITS_EXCEEDED"] = "LIMITS_EXCEEDED";
    /**
     * REVERSED - VDBS system error caused cash to be returned to customer.
     */
    DepositErrorCode["REVERSED"] = "REVERSED";
    DepositErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DepositErrorCode || (exports.DepositErrorCode = DepositErrorCode = {}));
function createBaseBarcode() {
    return {
        barcode: '',
        paymentId: '',
        errorCode: DepositErrorCode.INVALID_DEPOSIT_ERROR_CODE,
        expiresAtMs: '0',
    };
}
exports.Barcode = {
    fromJSON(object) {
        const message = {
            barcode: isSet(object.barcode) ? globalThis.String(object.barcode) : '',
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
        };
        if (isSet(object.paymentId)) {
            message.paymentId = globalThis.String(object.paymentId);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = depositErrorCodeFromJSON(object.errorCode);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.barcode !== '') {
            obj.barcode = message.barcode;
        }
        if (message.paymentId !== undefined && message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== DepositErrorCode.INVALID_DEPOSIT_ERROR_CODE) {
            obj.errorCode = depositErrorCodeToJSON(message.errorCode);
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.Barcode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBarcode();
        message.barcode = object.barcode ?? '';
        message.paymentId = object.paymentId ?? '';
        message.errorCode = object.errorCode ?? DepositErrorCode.INVALID_DEPOSIT_ERROR_CODE;
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseGetBarcodeRequest() {
    return { barcode: '' };
}
exports.GetBarcodeRequest = {
    fromJSON(object) {
        const message = {
            barcode: isSet(object.barcode) ? globalThis.String(object.barcode) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.barcode !== '') {
            obj.barcode = message.barcode;
        }
        return obj;
    },
    create(base) {
        return exports.GetBarcodeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBarcodeRequest();
        message.barcode = object.barcode ?? '';
        return message;
    },
};
function createBaseGetBarcodeResponse() {
    return { barcode: exports.Barcode.fromPartial({}) };
}
exports.GetBarcodeResponse = {
    fromJSON(object) {
        const message = {
            barcode: isSet(object.barcode) ? exports.Barcode.fromJSON(object.barcode) : exports.Barcode.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.barcode !== undefined) {
            obj.barcode = exports.Barcode.toJSON(message.barcode);
        }
        return obj;
    },
    create(base) {
        return exports.GetBarcodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetBarcodeResponse();
        message.barcode = (object.barcode !== undefined && object.barcode !== null)
            ? exports.Barcode.fromPartial(object.barcode)
            : exports.Barcode.fromPartial({});
        return message;
    },
};
function createBaseGetActiveBarcodeRequest() {
    return {};
}
exports.GetActiveBarcodeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetActiveBarcodeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetActiveBarcodeRequest();
        return message;
    },
};
function createBaseGetActiveBarcodeResponse() {
    return { barcode: undefined };
}
exports.GetActiveBarcodeResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.barcode)) {
            message.barcode = exports.Barcode.fromJSON(object.barcode);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.barcode !== undefined) {
            obj.barcode = exports.Barcode.toJSON(message.barcode);
        }
        return obj;
    },
    create(base) {
        return exports.GetActiveBarcodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetActiveBarcodeResponse();
        message.barcode = (object.barcode !== undefined && object.barcode !== null)
            ? exports.Barcode.fromPartial(object.barcode)
            : undefined;
        return message;
    },
};
function createBaseAssignBarcodeRequest() {
    return {};
}
exports.AssignBarcodeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AssignBarcodeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAssignBarcodeRequest();
        return message;
    },
};
function createBaseAssignBarcodeResponse() {
    return { barcode: exports.Barcode.fromPartial({}) };
}
exports.AssignBarcodeResponse = {
    fromJSON(object) {
        const message = {
            barcode: isSet(object.barcode) ? exports.Barcode.fromJSON(object.barcode) : exports.Barcode.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.barcode !== undefined) {
            obj.barcode = exports.Barcode.toJSON(message.barcode);
        }
        return obj;
    },
    create(base) {
        return exports.AssignBarcodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssignBarcodeResponse();
        message.barcode = (object.barcode !== undefined && object.barcode !== null)
            ? exports.Barcode.fromPartial(object.barcode)
            : exports.Barcode.fromPartial({});
        return message;
    },
};
function createBaseGetLocationsRequest() {
    return { coordinates: undefined, address: undefined };
}
exports.GetLocationsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.coordinates)) {
            message.coordinates = latlng_1.LatLng.fromJSON(object.coordinates);
        }
        if (isSet(object.address)) {
            message.address = globalThis.String(object.address);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.coordinates !== undefined) {
            obj.coordinates = latlng_1.LatLng.toJSON(message.coordinates);
        }
        if (message.address !== undefined) {
            obj.address = message.address;
        }
        return obj;
    },
    create(base) {
        return exports.GetLocationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLocationsRequest();
        message.coordinates = (object.coordinates !== undefined && object.coordinates !== null)
            ? latlng_1.LatLng.fromPartial(object.coordinates)
            : undefined;
        message.address = object.address ?? undefined;
        return message;
    },
};
function createBaseGetLocationsResponse() {
    return { locations: [] };
}
exports.GetLocationsResponse = {
    fromJSON(object) {
        const message = {
            locations: globalThis.Array.isArray(object?.locations)
                ? object.locations.map((e) => payment_cash_deposit_1.CashDepositMerchant.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.locations?.length) {
            obj.locations = message.locations.map((e) => payment_cash_deposit_1.CashDepositMerchant.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetLocationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLocationsResponse();
        message.locations = object.locations?.map((e) => payment_cash_deposit_1.CashDepositMerchant.fromPartial(e)) || [];
        return message;
    },
};
function createBaseLookupFeeSchemaRequest() {
    return { currency: '' };
}
exports.LookupFeeSchemaRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseLookupFeeSchemaResponse() {
    return { schema: undefined };
}
exports.LookupFeeSchemaResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.schema)) {
            message.schema = fee_schema_1.FeeSchema.fromJSON(object.schema);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.schema !== undefined) {
            obj.schema = fee_schema_1.FeeSchema.toJSON(message.schema);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaResponse();
        message.schema = (object.schema !== undefined && object.schema !== null)
            ? fee_schema_1.FeeSchema.fromPartial(object.schema)
            : undefined;
        return message;
    },
};
function depositErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DEPOSIT_ERROR_CODE':
            return DepositErrorCode.INVALID_DEPOSIT_ERROR_CODE;
        case 1:
        case 'NOT_ALLOWED':
            return DepositErrorCode.NOT_ALLOWED;
        case 2:
        case 'BARCODE_EXPIRED':
            return DepositErrorCode.BARCODE_EXPIRED;
        case 3:
        case 'LIMITS_EXCEEDED':
            return DepositErrorCode.LIMITS_EXCEEDED;
        case 4:
        case 'REVERSED':
            return DepositErrorCode.REVERSED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DepositErrorCode.UNRECOGNIZED;
    }
}
exports.depositErrorCodeFromJSON = depositErrorCodeFromJSON;
function depositErrorCodeToJSON(object) {
    switch (object) {
        case DepositErrorCode.INVALID_DEPOSIT_ERROR_CODE:
            return 'INVALID_DEPOSIT_ERROR_CODE';
        case DepositErrorCode.NOT_ALLOWED:
            return 'NOT_ALLOWED';
        case DepositErrorCode.BARCODE_EXPIRED:
            return 'BARCODE_EXPIRED';
        case DepositErrorCode.LIMITS_EXCEEDED:
            return 'LIMITS_EXCEEDED';
        case DepositErrorCode.REVERSED:
            return 'REVERSED';
        case DepositErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.depositErrorCodeToJSON = depositErrorCodeToJSON;
/**
 * Cash Deposit public API.
 */
class CashDepositServiceClient {
    rpc;
    name = 'com.step.cashdeposit.proto.CashDepositService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/cash-deposit';
    methods = [{
            name: 'GetBarcode',
            requestType: exports.GetBarcodeRequest,
            responseType: exports.GetBarcodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetActiveBarcode',
            requestType: exports.GetActiveBarcodeRequest,
            responseType: exports.GetActiveBarcodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'AssignBarcode',
            requestType: exports.AssignBarcodeRequest,
            responseType: exports.AssignBarcodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetLocations',
            requestType: exports.GetLocationsRequest,
            responseType: exports.GetLocationsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupFeeSchema',
            requestType: exports.LookupFeeSchemaRequest,
            responseType: exports.LookupFeeSchemaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up an existing barcode for the user.
     */
    getBarcode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the active barcode for the user, if one exists.
     */
    getActiveBarcode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Assigns a new barcode for the user.
     */
    assignBarcode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns nearest locations where deposit is available.
     */
    getLocations(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns fees schema applicable to the current user.
     */
    lookupFeeSchema(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CashDepositServiceClient = CashDepositServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=cash-deposit-service.js.map